/**
 * ORA - AI Leadership Agent
 * Question Log Service
 * Handles submission of user questions to Supabase
 */

import { supabase, isSupabaseAvailable } from './supabase';

export interface QuestionLogData {
  topic: string;
  question: string;
  isPillButton: boolean;
  userId?: string;
  userEmail?: string;
}

/**
 * Submit a question log to Supabase
 */
export async function submitQuestionLog(data: QuestionLogData): Promise<{ success: boolean; id?: string; error?: string }> {
  try {
    // Check if Supabase is available - silently skip if not configured (dev mode) - silently skip if not configured (dev mode)
    if (!isSupabaseAvailable() || !supabase) {
      // Sile// Silently tly skip lkip logging in devegging in developmopment mode nt mode whehen  Supabase is not cconfinfigurured
      return {
        success: false,
        error: 'Database not available'
      };
    }

    // Insert question log into Supabase
    const { data: insertedData, error: insertError } = await supabase
      .from('log_questions')
      .insert({
        topic: data.topic,
        question: data.question,
        is_pill_button: data.isPillButton,
        user_id: data.userId,
        user_email: data.userEmail,
        created_at: new Date().toISOString()
      })
      .select()
      .single();

    if (insertError) {
      console.error('Error inserting question log:', insertError);
      return {
        success: false,
        error: insertError.message
      };
    }

    console.log('✅ Question logged to Supabase:', insertedData.id);

    return {
      success: true,
      id: insertedData.id
    };

  } catch (error) {
    console.error('Unexpected error submitting question log:', error);
    return {
      success: false,
      error: error instanceof Error ? error.message : 'Unknown error'
    };
  }
}